import axios from "./config";
import { API } from "./api";

export const getCategoriesService = async (typeId) => {
  return axios
    .get(`${API.programBuilder.root}${API.programBuilder.categories}`, { params: { typeId } })
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const getProgProductsService = async (categoryId) => {
  return axios
    .get(`${API.programBuilder.root}${API.programBuilder.products}`, { params: { categoryId } })
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const getProgLaborCodesService = async (categoryId) => {
  return axios
    .get(`${API.programBuilder.root}${API.programBuilder.laborCodes}`, { params: { categoryId } })
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const programSearchService = async (data) => {
  return axios
    .get(`${API.programBuilder.root}${API.programBuilder.searchProgram}`, { params: data })
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const createProgramService = async (body) => {
  return axios
    .post(`${API.programBuilder.root}${API.programBuilder.createProgram}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const addCategoriesService = async (body) => {
  return axios
    .post(`${API.programBuilder.root}${API.programBuilder.productCategory}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const addLineItemsService = async (body) => {
  return axios
    .post(`${API.programBuilder.root}${API.programBuilder.lineItem}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const getCategoriesListService = async (programId) => {
  return axios
    .get(`${API.programBuilder.root}${API.programBuilder.getCategoriesList.replace("{0}", programId)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const getLineItemsService = async (programId) => {
  return axios
    .get(`${API.programBuilder.root}${API.programBuilder.getLineItems.replace("{0}", programId)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const getProgramDetailsService = async (programId) => {
  return axios
    .get(`${API.programBuilder.root}${API.programBuilder.getProgramDetails.replace("{0}", programId)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const getLineItemPricesService = async (programId) => {
  return axios
    .get(`${API.programBuilder.root}${API.programBuilder.getLineItemPrices.replace("{0}", programId)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const addLineItemPricesService = async (body) => {
  return axios
    .post(`${API.programBuilder.root}${API.programBuilder.addLineItemPrices}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const updateLineItemPricesService = async (body) => {
  return axios
    .patch(`${API.programBuilder.root}${API.programBuilder.addLineItemPrices}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const editProgramDetailService = async (body) => {
  return axios
    .patch(`${API.programBuilder.root}${API.programBuilder.createProgram}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const updateLineItemDataService = async (body) => {
  return axios
    .patch(`${API.programBuilder.root}${API.programBuilder.lineItem}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const deleteLineItemDataService = async (id) => {
  return axios
    .delete(`${API.programBuilder.root}${API.programBuilder.lineItem}/${id}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};

export const deleteProductDataService = async (id) => {
  return axios
    .delete(`${API.programBuilder.root}${API.programBuilder.productCategory}/${id}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => Promise.reject(err));
};
